import { useEffect } from "react";

export const prefersReducedMotion = () =>
  Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches);

/**
 * Fades in elements marked with data-reveal as they scroll into view. Pass `rescanKey`
 * (e.g. the language) to observe again when content is re-rendered with new elements.
 */
export function useReveal(rootRef, rescanKey) {
  useEffect(() => {
    const elements = rootRef.current?.querySelectorAll("[data-reveal]:not(.visible)") ?? [];
    const reveal = (el) => el.classList.add("visible");

    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      elements.forEach(reveal);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px" }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [rootRef, rescanKey]);
}
